var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuEllipse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7419 11.7419C13.7419 10.7984 12.9435 10 12 10C11.0323 10 10.2581 10.7984 10.2581 11.7419C10.2581 12.7097 11.0323 13.4839 12 13.4839C12.9435 13.4839 13.7419 12.7097 13.7419 11.7419ZM16.2581 10C15.2903 10 14.5161 10.7984 14.5161 11.7419C14.5161 12.7097 15.2903 13.4839 16.2581 13.4839C17.2016 13.4839 18 12.7097 18 11.7419C18 10.7984 17.2016 10 16.2581 10ZM7.74194 10C6.77419 10 6 10.7984 6 11.7419C6 12.7097 6.77419 13.4839 7.74194 13.4839C8.68548 13.4839 9.48387 12.7097 9.48387 11.7419C9.48387 10.7984 8.68548 10 7.74194 10Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuEllipse);
export default __webpack_public_path__ + "static/media/menu-ellipse.06bc9636d080c7a164eae53797d8fb93.svg";
export { ForwardRef as ReactComponent };